// extracted by mini-css-extract-plugin
export default {"brandsList":"brands-list_brandsList__oHtu9"};